import { AUTH_API, handleApiError } from '../../utils/axios';

export const getVisitImages = async (vin, visitId) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/vehicles/${vin}/visits/${visitId}/images`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createVisitImage = async (vin, visitId, image) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/vehicles/${vin}/visits/${visitId}/images`, image);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteVisitImage = async (vin, visitId, imageId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/vehicles/${vin}/visits/${visitId}/images/${imageId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
